/* AJOVITAL.JS — interacciones de las secciones ajovital-* (tabs, carruseles,
   contador por visitante compartido entre banner y hero, cifras animadas). Event delegation para sobrevivir a
   los re-render del editor de Shopify. */
(function () {
  'use strict';

  // En móvil, las secciones [data-av-stack] muestran todos los paneles apilados
  // y los botones actúan como anclas (ver ajovital.css, bloque responsive).
  var mobile = window.matchMedia('(max-width: 989px)');

  function setActive(root, idx) {
    root.querySelectorAll('[data-av-tab]').forEach(function (b) {
      var on = b.getAttribute('data-av-tab') === idx;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-av-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-av-panel') === idx);
    });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-av-tab]');
    if (tab) {
      var root = tab.closest('[data-av-tabs]');
      if (!root) return;
      var idx = tab.getAttribute('data-av-tab');
      setActive(root, idx);
      if (mobile.matches && root.hasAttribute('data-av-stack')) {
        var panel = root.querySelector('.ajovital-problem__panel[data-av-panel="' + idx + '"], .ajovital-benefits__panel[data-av-panel="' + idx + '"]');
        if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    // Reseñas en móvil: revela las tarjetas ocultas tras la 3.ª
    var more = e.target.closest('[data-av-more]');
    if (more) {
      var list = more.closest('section').querySelector('[data-av-collapsed]');
      if (list) list.removeAttribute('data-av-collapsed');
      more.setAttribute('aria-expanded', 'true');
      more.hidden = true;
      return;
    }

    var arrow = e.target.closest('[data-av-prev],[data-av-next]');
    if (arrow) {
      var track = arrow.closest('[data-av-carousel]').querySelector('[data-av-track]');
      var dir = arrow.hasAttribute('data-av-next') ? 1 : -1;
      track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
    }
  });

  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var END_KEY = 'ajovital_countdown_end_v1';
  function countdownEnd() {
    var hoursEl = document.querySelector('[data-av-hours]');
    var hours = hoursEl ? parseInt(hoursEl.getAttribute('data-av-hours'), 10) || 12 : 12;
    var now = Date.now();
    var end = 0;
    try { end = parseInt(sessionStorage.getItem(END_KEY) || '0', 10); } catch (e) {}
    if (!end || end <= now) {
      end = now + hours * 3600000;
      try { sessionStorage.setItem(END_KEY, String(end)); } catch (e) {}
    }
    return end;
  }
  function tickCountdowns() {
    var left = Math.max(0, Math.floor((countdownEnd() - Date.now()) / 1000));
    var h = pad(Math.floor(left / 3600));
    var m = pad(Math.floor((left % 3600) / 60));
    var s = pad(left % 60);
    document.querySelectorAll('[data-av-countdown]').forEach(function (el) {
      var hEl = el.querySelector('[data-av-h]');
      if (!hEl) return;
      hEl.textContent = h;
      el.querySelector('[data-av-m]').textContent = m;
      el.querySelector('[data-av-s]').textContent = s;
    });
  }

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function animateCount(el) {
    var target = parseInt(el.getAttribute('data-av-count'), 10);
    if (isNaN(target)) { el.textContent = el.getAttribute('data-av-count'); return; }
    if (reduced) { el.textContent = target; return; }
    var start = null;
    var step = function (ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / 1400);
      el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }
  function initCounters(scope) {
    var els = (scope || document).querySelectorAll('[data-av-count]:not([data-av-done])');
    if (!('IntersectionObserver' in window)) { els.forEach(animateCount); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.setAttribute('data-av-done', '');
        animateCount(en.target);
        io.unobserve(en.target);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  // Packs del hero: el índice elegido se replica en las ofertas de EasySell
  // (.es-qo-container, mismo orden) cuando se abre su formulario.
  var packIdx = null;

  function selectPack(btn) {
    var root = btn.closest('[data-av-packs]');
    root.querySelectorAll('[data-av-pack]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    root.querySelector('[data-av-pack-price]').textContent = btn.getAttribute('data-price');
    root.querySelector('[data-av-pack-compare]').textContent = btn.getAttribute('data-compare');
    root.querySelector('[data-av-pack-save]').textContent = btn.getAttribute('data-save');
    packIdx = parseInt(btn.getAttribute('data-av-pack'), 10);
  }

  function initPacks() {
    var sel = document.querySelector('[data-av-packs] .ajovital-pack.is-selected');
    if (sel) packIdx = parseInt(sel.getAttribute('data-av-pack'), 10);
  }

  function visibleOffers() {
    return Array.prototype.filter.call(document.querySelectorAll('.es-qo-container'), function (c) { return c.offsetParent; });
  }

  function applyPackToForm() {
    // Si el formulario ya está abierto, respetamos lo que el cliente elija dentro.
    if (packIdx === null || visibleOffers().length) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var offers = visibleOffers();
      if (offers.length > packIdx) {
        clearInterval(timer);
        offers[packIdx].click();
      } else if (tries > 40) {
        clearInterval(timer);
      }
    }, 150);
  }

  document.addEventListener('click', function (e) {
    var pack = e.target.closest('[data-av-pack]');
    if (pack) { selectPack(pack); return; }
    if (e.target.closest('.es-popup-button, [class*="es-popup-button"], [class*="es-sticky"]')) applyPackToForm();
  }, true);

  function initStacks(scope) {
    if (!('IntersectionObserver' in window)) return;
    (scope || document).querySelectorAll('[data-av-stack]').forEach(function (root) {
      if (root.hasAttribute('data-av-stack-ready')) return;
      root.setAttribute('data-av-stack-ready', '');
      var io = new IntersectionObserver(function (entries) {
        if (!mobile.matches) return;
        entries.forEach(function (en) {
          if (en.isIntersecting) setActive(root, en.target.getAttribute('data-av-panel'));
        });
      }, { rootMargin: '-35% 0px -55% 0px' });
      root.querySelectorAll('.ajovital-problem__panel, .ajovital-benefits__panel').forEach(function (p) { io.observe(p); });
    });
  }

  function init() {
    tickCountdowns();
    initCounters();
    initStacks();
    initPacks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  setInterval(tickCountdowns, 1000);
  document.addEventListener('shopify:section:load', function (e) { initCounters(e.target); initStacks(e.target); tickCountdowns(); });
})();
